import { TOTAL_SECONDS } from "../lib/game-state";

interface GameTimerBarProps {
  timeLeft: number;
  totalSeconds?: number;
}

function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function GameTimerBar({
  timeLeft,
  totalSeconds = TOTAL_SECONDS,
}: GameTimerBarProps) {
  const pct = Math.max(0, Math.min(100, (timeLeft / totalSeconds) * 100));
  const urgent = timeLeft <= 15;

  return (
    <div
      className={`act-gametimer${urgent ? " act-gametimer--urgent" : ""}`}
      role="timer"
      aria-label={`${formatTime(timeLeft)} resterend`}
    >
      <div className="act-gametimer__track">
        <div
          className="act-gametimer__fill"
          style={{ width: `${pct}%` }}
        />
        <span className="act-gametimer__label">{formatTime(timeLeft)}</span>
      </div>
    </div>
  );
}
